import { ProductMenu } from '../product-menu';
import { OpacityLocation } from '../../shared/opacity-location.enum';
import { Type } from '@angular/core';
import { MenuSectionHeaderComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-section-header/menu-section-header.component';
import { RuntzSectionHeaderComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-section-header/runtz-section-header/runtz-section-header.component';
import { EmptyMenuFooterComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-footer/empty-menu-footer/empty-menu-footer.component';
import { ProductMenuFooterComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-footer/product-menu-footer.component';
import { MenuHeaderTitleImageComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-header/menu-header-title/menu-header-title-image/menu-header-title-image.component';
import { FONT, FontStyleSheet } from '../font-style-sheets';
import { SectionColumnType } from '../../enum/shared/section-column-type';
import { SectionColumnProductInfoType } from '../../enum/shared/section-column-product-info-type';
import { SectionColumnViewModel } from 'src/app/modules/display/components/menus/product-menu/building-blocks/menu-section/product-section/section-column-view-models/SectionColumnViewModel';
import { WithinNameCell } from '../../enum/shared/within-name-cell';

export class RuntzMenu extends ProductMenu {
  getThemeClass(): string {
    return 'runtz-theme';
  }

  getHeaderType(): Type<MenuHeaderTitleImageComponent> {
    return MenuHeaderTitleImageComponent;
  }

  getSectionsHeaderType(): Type<MenuSectionHeaderComponent> {
    return RuntzSectionHeaderComponent;
  }

  getFooterType(): Type<ProductMenuFooterComponent> {
    return EmptyMenuFooterComponent;
  }

  /* ************************** Framed Background ************************** */

  getSectionsWrapperClass(): string {
    return 'runtz-sections-container';
  }

  getOpacityLocation(): OpacityLocation {
    return OpacityLocation.SECTION_CONTAINER;
  }

  getSectionsBackgroundColor(): string {
    return this.getBackgroundColorWithOpacity();
  }

  /* *********************************************************************** */

  getTitleSectionBottomMargin(): string {
    return '0';
  }

  getShowInlineLabels(): WithinNameCell {
    return WithinNameCell.TitleLine;
  }

  getSectionHeaderUnderlined(): boolean {
    return false;
  }

  getColumnGroupingSpacerWidthPercentage(): number {
    return 0;
  }

  getShowProductSubtitle(): boolean {
    return false;
  }

  override getColumnOrdering(): Map<SectionColumnType, number> {
    return new Map<SectionColumnType, number>([
      [SectionColumnProductInfoType.Badge, 0],
      [SectionColumnProductInfoType.ProductTitle, 1],
      [SectionColumnProductInfoType.Strain, 2],
      [SectionColumnProductInfoType.StrainType, 3],
      [SectionColumnProductInfoType.Brand, 4],
      [SectionColumnProductInfoType.QuantityAndSize, 5],
      [SectionColumnProductInfoType.Quantity, 6],
      [SectionColumnProductInfoType.Size, 7],
      [SectionColumnProductInfoType.VariantType, 8],
      [SectionColumnProductInfoType.Stock, 9],
      ...SectionColumnViewModel.getDefaultAdditionalDetailsColumnOrder(10),
      SectionColumnViewModel.getDefaultProductTagGroupColumnOrdering(11),
      ...SectionColumnViewModel.getDefaultCannabinoidColumnOrdering(12),
      ...SectionColumnViewModel.getDefaultTerpeneColumnOrdering(13),
      [SectionColumnProductInfoType.GradingResults, 14],
      [SectionColumnProductInfoType.VariantPrice, 15],
      [SectionColumnProductInfoType.VariantSecondaryPrice, 16]
    ]);
  }

  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [FONT.Poppins.Medium_500, FONT.WorkSans.SemiBold_600, FONT.WorkSans.Medium_500, FONT.WorkSans.Bold_700];
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return 'https://use.typekit.net/rym7xrk.css';
  }
}
